export default {"src":"/uk/_next/static/media/telephoneYellowIcon.bdd799c1.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};